import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AdminPanel from './components/AdminPanel';
import TenantDetails from './components/TenantDetails';

/**
 * Main Application Component
 * 
 * Root component that sets up routing for the SureCost Vendor Dashboard.
 * Handles navigation between login and dashboard views.
 * 
 * Routes:
 * - / : Login page with magic link authentication
 * - /dashboard : Protected dashboard for authenticated users
 * 
 * @author SureCost Development Team
 * @version 1.0.0
 */
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public route - Login page */}
          <Route 
            path="/" 
            element={<Login />} 
          />
          
          {/* Protected route - Dashboard */}
          <Route 
            path="/dashboard" 
            element={<Dashboard />} 
          />
          
          {/* Admin route - Tenant Management */}
          <Route 
            path="/admin" 
            element={<AdminPanel />} 
          />
          
          {/* Tenant Details route */}
          <Route 
            path="/admin/tenant/:tenantId" 
            element={<TenantDetails />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;